import React, { useState } from 'react';

import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';

import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import ModalUDeactConfirm from '../modals/ModalUDeactConfirm.jsx';

const ListCtrlActivates = ({
  api,
  selected,
  onSuccess,
  deactivateAll = false,
}) => {
  const [res, req] = useHttpStatus();
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      {selected.length > 0 && (
        <>
          <FormHttpBtn
            res={res}
            className="btn btn-link"
            icon={faEye}
            onClick={async () => {
              await req({
                url: `${api}/active`,
                method: 'patch',
                data: { _id: selected.map((s) => s._id), active: true },
              });

              onSuccess();
            }}
          />
          <FormHttpBtn
            res={res}
            className="btn btn-link"
            icon={faEyeSlash}
            onClick={async () => {
              await req({
                url: `${api}/active`,
                method: 'patch',
                data: { _id: selected.map((s) => s._id), active: false },
              });

              onSuccess();
            }}
          />
        </>
      )}
      {deactivateAll && (
        <>
          <FormHttpBtn
            res={res}
            className="btn btn-danger float-right"
            icon={faEyeSlash}
            onClick={() => setModalShow(true)}
          >All</FormHttpBtn>
          <ModalUDeactConfirm
            show={modalShow}
            onReject={() => setModalShow(false)}
            onConfirm={async () => {
              setModalShow(false);
              await req({
                url: `${api}/active`,
                method: 'patch',
                data: { all: true, active: false },
              });
              onSuccess();
            }}
          />
        </>
      )}
    </>
  );
};

export default ListCtrlActivates;
